import React from 'react';
import {
    Dialog,
    DialogContent,
    Typography,
    Box,
    LinearProgress,
    Button
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { intl } from 'dmsbasereact';
import { APP_COLORS } from '../../../theme/appTheme';

export const SuccessModal = ({
    open,
    onClose,
    createdUserName,
    countdown,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 2,
                }
            }}
        >
            <DialogContent sx={{ textAlign: 'center', py: 4 }}>
                <CheckCircleOutlineIcon
                    sx={{
                        fontSize: 80,
                        color: 'success.main',
                        mb: 2,
                    }}
                />
                <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: 'success.main' }}>
                    {intl.get("AccountCreatedSuccessfully").d("Account Created Successfully!")}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
                    {intl.get("WelcomeMessage").d("Welcome to Programa Lena,")} <strong>{createdUserName}</strong>!
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                    {intl.get("AccountCreatedEmailSent").d("A welcome email has been sent to your inbox.")}
                </Typography>
                <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
                    {intl.get("RedirectingToLogin").d("You will be redirected to the login page in")}
                </Typography>

                <Box sx={{ mb: 3 }}>
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 700,
                            color: APP_COLORS.primary.main || 'primary.main',
                        }}
                    >
                        {countdown}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {intl.get("Seconds").d("seconds")}
                    </Typography>
                </Box>

                <LinearProgress
                    variant="determinate"
                    value={(5 - countdown) * 20}
                    sx={{
                        height: 8,
                        borderRadius: 4,
                        mb: 3,
                        backgroundColor: 'grey.200',
                        '& .MuiLinearProgress-bar': {
                            backgroundColor: 'success.main',
                            borderRadius: 4,
                        }
                    }}
                />

                <Button
                    variant="contained"
                    color="primary"
                    onClick={onClose}
                    size="large"
                    sx={{ minWidth: 200 }}
                >
                    {intl.get("GoToLoginNow").d("Go to Login Now")}
                </Button>
            </DialogContent>
        </Dialog>
    );
};
